
<template>
    <div class="field_total">
        <div class="field_static_width field_total_">
            Всього
        </div>
        
        <div class="dolznost field_total_"></div>
        <div class="shtat field_total_">
            {{field.shtat}}
        </div>
        <div class="field_total_ big"></div>
        <div class="field_total_ medium"></div>
        <div class="field_total_ small"></div>
        <div class="field_total_ big"></div>
        <div class="field_total_ medium_10"></div>
        <div class="field_total_ medium"></div>
        <div class="field_total_ medium_10"></div>
        <div class="field_total_ last_child">
            {{field.all_fop | toNiceNumber}}
        </div>
        <div class="clr"></div>
    </div>
</template>


<script>
export default {
    name: "kadr_field_total",
    props : {
        field : {
            type : Object,
            require : true,
        }
    }
}
</script>


<style scoped>

</style>